import React from 'react';

import { TextField, Typography } from '@mui/material';

interface TextEditorBaseProps {
  title?: string;
  paragraph?: string;
  onPropChange: (key: string, value: any) => void;
}

const TextEditorBase: React.FC<TextEditorBaseProps> = ({
  title,
  paragraph,
  onPropChange,
}) => {
  return (
    <>
      <Typography variant="h6">Content Options</Typography>
      <TextField
        label="Title"
        value={title || ''}
        onChange={(e) => onPropChange('title', e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Paragraph"
        value={paragraph || ''}
        onChange={(e) => onPropChange('paragraph', e.target.value)}
        fullWidth
        multiline
        margin="normal"
      />
    </>
  );
};

export default TextEditorBase;
